import WidgetGrid from "@components/widgets/Grid";
import { useParams } from "react-router-dom";
import { useFilterParamsV4 } from "@/hooks/useFilterParams";
import { withDefaultDates } from "@/utils";
import { differenceInDays } from "date-fns";
import SentimentOverTimeWidget from "./partials/widgets/SentimentOverTime";
import MentionsInsightsSentimentViewMentionCards from "./partials/MentionCards";
import SentimentsWidgets from "./partials/widgets/Sentiments";
import TopSourcesPositiveWidget from "./partials/widgets/TopSourcesPositive";
import TopSourcesNegativeWidget from "./partials/widgets/TopSourcesNegative";

export default function MentionsInsightsSentimentView() {
  // URL state
  const { orgUuid, uuid } = useParams<{ orgUuid: Uuid; uuid: Uuid }>();
  const [_filters] = useFilterParamsV4();

  // Helpers
  const filters = withDefaultDates(_filters);
  const diffInDays = differenceInDays(filters.end_date, filters.start_date);

  return (
    <div className="flex flex-col gap-8" data-testid="insights-sentiment-page">
      <WidgetGrid>
        <SentimentsWidgets
          diffInDays={diffInDays}
          searchUuid={uuid}
          filters={filters}
        />

        <SentimentOverTimeWidget
          className="col-span-12 @4xl/grid:col-span-12 h-96"
          diffInDays={diffInDays}
          searchUuid={uuid}
          filters={filters}
        />

        <TopSourcesPositiveWidget
          className="col-span-12 min-h-150 @4xl/grid:col-span-6"
          searchUuid={uuid}
          filters={filters}
        />

        <TopSourcesNegativeWidget
          className="col-span-12 min-h-150 @4xl/grid:col-span-6"
          searchUuid={uuid}
          filters={filters}
        />
      </WidgetGrid>

      <MentionsInsightsSentimentViewMentionCards
        searchUuid={uuid}
        filters={filters}
        orgUuid={orgUuid}
      />
    </div>
  );
}
